
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table, TableRowsSelect } from "@common/src/utils/decorator";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import DataImport from "@common/src/components/scope/data-import/index.vue";
import SwitchStatus from "@common/src/components/scope/switch-status/index.vue";
import t from "@common/src/i18n/t";
import { addCurrencyUnit, addCurrencySymbol, permitCountry } from "@common/src/utils/tools";
import CustomerFlag from "@common/src/components/scope/customer-flag/index.vue";
import TextTips from "@common/src/components/scope/text-tips/index.vue";
import dayjs from "dayjs";

const customer = namespace("customer");
const base = namespace("base");
const common_app = namespace("common_app");
@Component({
  components: { DataImport, SwitchStatus, CustomerFlag, TextTips }
})
@Table("loadListData")
@TableRowsSelect({
  warningMsg: t("v210906.please-select-at-least-one-customer"),
  updateStatusFuncName: "confirmUpdateStatus",
  tableRefKey: "table",
  checkableFuncName: "checkable"
})
@Table.DataImport({
  templateUrl: "https://static.gtech.asia/static/template/speedbiz/客户车辆导入.xlsx",
  actionUrl: "/filecloud/importCustomerVehicles"
})
export default class Customer extends Vue {
  @customer.Action getCustomerList;
  splitThousands = splitThousands;
  @customer.Action updateCustomerStatus;
  @customer.Action batchUpdateVehicleStatus;
  @customer.Action queryCustomerConsumeList;
  @base.Action getDictionaryList;
  @common_app.State country;
  emptyToLine = emptyToLine;
  dayjs = dayjs;
  addCurrencyUnit = addCurrencyUnit;
  addCurrencySymbol = addCurrencySymbol;
  permitCountry = permitCountry;
  searchForm = {
    plateCode: "",
    vinCode: "",
    customerName: "",
    mobile: "",
    status: "2",
    labelDesc: ""
  };
  showImport: boolean = false;
  customerList: any[] = [];
  get searchList() {
    return [
      {
        label: t("finance.license-plate-number"),
        type: "input",
        value: "",
        prop: "plateCode"
      },
      {
        label: t("test.vin-code"),
        type: "input",
        value: "",
        prop: "vinCode"
      },
      {
        label: t("finance.guest-names"),
        type: "input",
        value: "",
        prop: "customerName"
      },
      {
        label: t("base.phone"),
        type: "input",
        value: "",
        prop: "mobile"
      },
      {
        label: t("base.enable-state"),
        type: "select",
        selectList: [
          {
            label: t("base.enabled"),
            value: "1"
          },
          {
            label: t("base.disable"),
            value: "0"
          },
          {
            label: t("base.all"),
            value: "2"
          }
        ],
        value: "2",
        prop: "status"
      },
      {
        label: t("v212.customer-label"),
        type: "input",
        value: "",
        prop: "labelDesc"
      },
      ...(permitCountry("china")
        ? [
            {
              label: t("v212.store-applet-authorization-status"),
              type: "select",
              selectList: this.authorizedMiniProgramOptionList,
              value: "",
              prop: "authorizedMiniProgram"
            },
            {
              label: t("setting.is-that-member"),
              type: "select",
              selectList: this.joinedMemberOptionList,
              value: "",
              prop: "joinedMember"
            }
          ]
        : [])
    ];
  }

  created() {
    this.init();
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.value;
      }
    });
    this.loadListData();
  }
  @TableRowsSelect.updateMethod
  confirmUpdateStatus(status, selectedRow) {
    return this.batchUpdateVehicleStatus({
      status: status,
      vehicleCodeList: selectedRow ? [selectedRow.vehicleCode] : this.mix_selectedRows.map(item => item.vehicleCode)
    }).then(() => {
      this.$message.success(status ? t("setting.enable-successful") : t("setting.disable-success"));
      this.loadListData();
    });
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.getCustomerList({
      orderItems: this.mix_sortParams,
      ...this.searchForm,
      pageSize: this.mix_pageSize,
      pageNum: this.mix_pageNum
    }).then(data => {
      this.customerList = data.data.list;
      return data;
    });
  }
  handleEdit(row) {
    this.$router.push(`/setting/customer-edit/${row.customerCode}?vehicleCode=${row.vehicleCode}`);
  }
  handleView(row) {
    this.$router.push(`/setting/customer-view/${row.customerCode}?vehicleCode=${row.vehicleCode}`);
  }
  handleShowImport() {
    this.showImport = true;
  }
  init() {
    this.loadListData();
    this.getDictionaryList("followed_official_account").then(data => {
      this.followedOfficialAccountOptionList = data;
    });
    this.getDictionaryList("authorized_mini_program").then(data => {
      this.authorizedMiniProgramOptionList = data;
    });
    this.getDictionaryList("joined_member").then(data => {
      this.joinedMemberOptionList = data;
    });
  }
  handleOpenOrder(url, row) {
    console.log(url, row);
    let { href } = this.$router.resolve(
      `${url}${url.includes("?") ? "&" : "?"}customerCode=${row.customerCode}&vehicleCode=${row.vehicleCode}`
    );
    window.open(href);
  }
  showConsumeRecord = false;
  consumeRecordList: any = [];
  consumeRecordData: any = {};
  handleShowConsumeRecord(row) {
    this.queryCustomerConsumeList({
      pageNum: 1,
      pageSize: 999,
      vehicleCode: row.vehicleCode
    }).then(data => {
      this.consumeRecordData = data.data;
      this.showConsumeRecord = true;
    });
  }
  followedOfficialAccountOptionList: any = [];
  authorizedMiniProgramOptionList: any = [];
  joinedMemberOptionList: any = [];
  checkable(row) {
    return !!row.vehicleCode;
  }
}
